export default __webpack_public_path__ + "static/media/card.3b30ecb3.svg";